export const styles = {
  noPermission: 'tw-p-6 tw-text-neutral-500',
};
